var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDemoArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 291,
    viewBox: "0 0 346 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0332 126.157C40.774 100.112 83.9352 98.05 120.71 107.966C143.41 114.052 164.553 124.313 185.121 135.503C205.689 146.693 226.027 158.255 245.445 171.302C267.092 185.73 287.13 202.759 302.275 223.954C303.929 226.263 307.981 225.945 309.989 224.361C312.342 222.22 312.05 218.956 310.396 216.647C282.202 177.096 237.836 152.46 196.373 129.363C156.21 107.071 112.261 87.5752 65.3843 92.7338C42.7908 95.1937 20.9406 103.51 3.68174 118.523C-1.62595 122.946 5.79632 130.881 11.0332 126.157Z",
    fill: "#FFAA78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286.937 141.223C295.015 166.78 299.368 193.372 299.855 220.397C302.164 218.743 304.473 217.089 306.897 215.249C284.276 206.129 260.992 198.911 237.001 194.081C234.011 193.515 231.145 194.824 230.278 197.885C229.455 200.46 231.092 204.042 234.082 204.608C258.073 209.438 281.472 216.47 303.978 225.776C307.295 227.058 311.01 223.962 311.019 220.627C310.505 192.814 306.241 165.249 297.765 138.675C296.942 135.853 294.271 133.942 291.263 134.65C288.255 135.358 285.929 138.286 286.937 141.223Z",
    fill: "#FFAA78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoArrow);
export default __webpack_public_path__ + "static/media/demo-arrow.67aaeaf2c4eac2425d3aa3a0e09adaba.svg";
export { ForwardRef as ReactComponent };